/* ============================================
   C.L.LINK — Shopify Dawn Custom JS
   ============================================ */

(function () {
  'use strict';

  /* -----------------------------------------------
     Hero Slider — handled inline in cl-hero-slider.liquid
     ----------------------------------------------- */

  /* -----------------------------------------------
     Mobile Menu
     ----------------------------------------------- */
  const mobileBtn = document.getElementById('clMobileBtn');
  const mobileClose = document.getElementById('clMobileClose');
  const overlay = document.getElementById('clOverlay');
  const panel = document.getElementById('clPanel');

  function openMobile() {
    if (panel) panel.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobile() {
    if (panel) panel.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (mobileBtn) mobileBtn.addEventListener('click', openMobile);
  if (mobileClose) mobileClose.addEventListener('click', closeMobile);
  if (overlay) overlay.addEventListener('click', closeMobile);

  // Accordion
  document.querySelectorAll('.cl-accordion-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const body = btn.nextElementSibling;
      const isOpen = body.classList.contains('open');
      // Close all
      document.querySelectorAll('.cl-accordion-body').forEach(function (b) { b.classList.remove('open'); });
      document.querySelectorAll('.cl-accordion-btn').forEach(function (b) { b.classList.remove('active'); });
      // Toggle current
      if (!isOpen) {
        body.classList.add('open');
        btn.classList.add('active');
      }
    });
  });

  /* -----------------------------------------------
     Search Overlay
     ----------------------------------------------- */
  const searchToggle = document.getElementById('clSearchToggle');
  const searchOverlay = document.getElementById('clSearchOverlay');
  const searchClose = document.getElementById('clSearchClose');
  const searchInput = document.getElementById('clSearchInput');

  function openSearch() {
    if (searchOverlay) {
      searchOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (searchInput) setTimeout(function () { searchInput.focus(); }, 350);
    }
  }
  function closeSearch() {
    if (searchOverlay) {
      searchOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  // Escape key closes search
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobile();
    }
  });

  /* -----------------------------------------------
     Mega Menu — Sidebar Hover
     ----------------------------------------------- */
  const megaSidebar = document.getElementById('clMegaSidebar');
  if (megaSidebar) {
    const items = megaSidebar.querySelectorAll('.cl-mega-sitem');
    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        // Remove active from all
        items.forEach(function (i) { i.classList.remove('active'); });
        document.querySelectorAll('.cl-mega-panel').forEach(function (p) { p.classList.remove('active'); });
        // Activate current
        item.classList.add('active');
        const target = document.getElementById(item.getAttribute('data-target'));
        if (target) target.classList.add('active');
      });
    });
  }

  /* -----------------------------------------------
     SP Account Menu
     ----------------------------------------------- */
  const accBtn = document.getElementById('clAccountSpBtn');
  const accMenu = document.getElementById('clAccountSpMenu');
  if (accBtn && accMenu) {
    accBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      accMenu.classList.toggle('open');
    });
    document.addEventListener('click', function () {
      accMenu.classList.remove('open');
    });
  }

  /* -----------------------------------------------
     Back to Top
     ----------------------------------------------- */
  const backTop = document.getElementById('clBackTop');
  if (backTop) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 400) {
        backTop.classList.add('visible');
      } else {
        backTop.classList.remove('visible');
      }
    }, { passive: true });

    backTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* -----------------------------------------------
     Header Scroll Effect
     ----------------------------------------------- */
  const header = document.getElementById('clHeader');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function () {
      const st = window.scrollY;
      if (st > 100) {
        header.style.boxShadow = '0 2px 20px rgba(0,0,0,0.15)';
      } else {
        header.style.boxShadow = 'none';
      }
      lastScroll = st;
    }, { passive: true });
  }

})();

/* 検索フォームの×ボタンで入力を確実にクリア */
document.addEventListener('click', function(e) {
  var resetBtn = e.target.closest('.reset__button');
  if (!resetBtn) return;
  var form = resetBtn.closest('form');
  if (!form) return;
  var input = form.querySelector('input[type="search"], input[name="q"]');
  if (input) {
    setTimeout(function() {
      input.value = '';
      input.focus();
      resetBtn.classList.add('hidden');
    }, 0);
  }
});